interface JwtPayload {
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

export function parseJwt(token: string): JwtPayload | null {
  try {
    const [, payloadb64] = token.split('.');
    if (!payloadb64) return null;
    // JWT uses base64url (RFC 7519): normalize to standard base64 before decoding.
    const normalized = payloadb64.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + (4 - (normalized.length % 4)) % 4, '=');
    return JSON.parse(atob(padded)) as JwtPayload;
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string, bufferMinutes = 5): boolean {
  const payload = parseJwt(token);
  if (!payload?.exp) return true;

  // Add buffer time (default 5 minutes) to refresh before actual expiration
  const bufferSeconds = bufferMinutes * 60;
  const expirationTime = payload.exp - bufferSeconds;
  const currentTime = Math.floor(Date.now() / 1000);

  return currentTime >= expirationTime;
}
